// extracted by mini-css-extract-plugin
export default {"Container":"Pricing_Container__9vlz0","Pricing":"Pricing_Pricing__CITMg"};